import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-faq-detail',
  templateUrl: './faq-detail.component.html',
  styleUrls: ['./faq-detail.component.scss']
})
export class FaqDetailComponent implements OnInit {
  
  @Input() selectedSectionDetail: any;
  constructor() { }

  ngOnInit(): void {
  }

}
